import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { appLogService } from '../../../store/slices/appLog';
import { useAppDispatch, useAppSelector, RootState } from '../../../store';
import { usePageStrings } from '../../../common/hooks';
import styles from './SSOCallback.module.scss';
import { Text, LinearProgress } from '../../../common/components';
import { signInWithAdfs, signInWithOkta } from '../../../store/slices/authorization';
import OktaAuth from '@okta/okta-auth-js';

// Handle Okta authorization code flow
async function handleOktaAuthorizationCode(authCode: string, dispatch: any, configuration: any, navigate: any) {
    try {

        let OrgUri = `https://${configuration.okta_AccountName}`;

        if(!!configuration.okta_AuthorizationServer){
            OrgUri = `${OrgUri}/oauth2/${configuration.okta_AuthorizationServer}`;
        }

        console.log('Okta OrgUri:', OrgUri);

        const oktaAuth = new OktaAuth({
            issuer: OrgUri,
            clientId: configuration.okta_AppId ?? '',
            redirectUri: configuration.okta_ReturnUrl,
            // scopes: ['openid', 'profile', 'email'],
            // responseType: ['token', 'id_token'],
            responseType: 'code',
            // pkce: false
            // headers: {
            //     "Access-Control-Allow-Origin": `https://trial-2332994.okta.com`
            // }
        });
        // Create Okta Auth instance with the same config as in SignIn
        // const oktaAuth = new OktaAuth({
        //     issuer: `https://${configuration.okta_AccountName}.okta.com`,
        //     clientId: configuration.okta_AppId ?? '',
        //     redirectUri: configuration.okta_RedirectUri,
        //     scopes: ['openid', 'profile', 'email'],
        //     responseType: ['token', 'id_token'],
        // });

        // Use the parseFromUrl method to handle the callback
        const tokens = await oktaAuth.token.parseFromUrl();

        if (tokens.tokens && tokens.tokens.idToken) {
            dispatch(signInWithOkta({
                token: tokens.tokens.idToken.idToken
            }));
        } else if (tokens.tokens && tokens.tokens.accessToken) {
            dispatch(signInWithOkta({
                token: tokens.tokens.accessToken.accessToken
            }));
        } else {
            throw new Error('No valid tokens received from Okta');
        }

    } catch (error: any) {
        console.error('handleOktaAuthorizationCode', 'Error processing authorization code:', error);
        appLogService.error("SSOCallback", "handleOktaAuthorizationCode", "Exception", error.message);
    }
}

export function SSOCallback() {

    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const pageStrings = usePageStrings();
    const [searchParams] = useSearchParams();
    const configuration = useAppSelector((state: RootState) => state.configuration);

    useEffect(() => {

        console.log('SSOCallback useEffect - Debug info:', {
            pathname: window.location.pathname,
            search: window.location.search,
            hash: window.location.hash
        });

        const currentPath = window.location.pathname;

        if (currentPath.includes('/authentication/sso/adfs-callback')) {

            const accessToken = searchParams.get('access_token');

            if (accessToken) {
                dispatch(signInWithAdfs({
                    token: accessToken
                }));
            }

        } else if (currentPath.includes('/authentication/sso/okta-callback')) {

            // Check if we have an authorization code (Authorization Code flow)
            const authCode = searchParams.get('code');

            if (authCode) {
                handleOktaAuthorizationCode(authCode, dispatch, configuration.authentication, navigate);
            }

        } else {
            appLogService.error("SSOCallback", "useEffect", "SSOProviderIdentity", "SSO Provider not found");
            navigate("/authentication/signIn");
        }

    }, [dispatch, navigate, searchParams]);

    return (
        <div className={styles["SSOCallback-content"]}>
            <div className={styles["SSOCallback-validating"]}>
                <p>
                    <Text fontStyle='body-large' value={pageStrings.resetPasswordPage.text_validatingToken}></Text>
                </p>
                <LinearProgress ariaLabel={pageStrings.resetPasswordPage.text_validatingToken}></LinearProgress>
            </div>
        </div>
    );
}